import { z } from "zod";
import { OTP_CODE_LENGTH } from "../constants/auth.js";
export const emailSchema = z.string().trim().pipe(z.email("Adresse e-mail invalide"));
export const otpCodeSchema = z.string().regex(new RegExp(`^\\d{${OTP_CODE_LENGTH}}$`), "Code invalide");
